/**
 * Test-sandbox manifest.
 *
 * Single source of truth for the "Test Sandboxes" section of the Development
 * channel. Adding a future sandbox is a ONE-LINE entry in SANDBOXES below —
 * the dev channel auto-renders one card per entry (title, description, Open
 * button, copyable route, async health dot). Nothing else to wire.
 */

export interface SandboxCard {
  /** Gateway prefix == card route prefix, e.g. 'cell-test'. */
  id: string;
  title: string;
  description: string;
  /** Gateway forward target host:port (documentation/reference only). */
  target: string;
  /** Path+fragment AFTER the /{id} prefix; may contain the literal token placeholder {TOKEN}. */
  route: string;
  /** Sandbox query token, if the sandbox self-gates; omit for tokenless. */
  token?: string;
}

export const SANDBOXES: SandboxCard[] = [
  {
    id: 'cell-test',
    title: 'Hub Cell — full app (test sandbox)',
    description:
      'The full Hub Cell app on the isolated hub-cell-test sandbox (own DB, no edge — Messages/Calls show offline). Opens on Automation → Graph: the n8n-style graph builder with save/load + sim runner, pan, scroll-zoom, add-node modal, yes/no branches, broken-flow flags. Auth-gated; test data only.',
    target: 'hub-cell-test:3001',
    route: '/?token={TOKEN}#automation',
    token: '3af836eb66aa6e09aa81566646692f19',
  },
  {
    id: 'people-test',
    title: 'Hub People — full app (test sandbox)',
    description:
      'The full Hub People app on the isolated hub-people-test sandbox (cloned data, separate DB; live untouched). Auth-gated; sandbox data only.',
    target: 'hub-people-test:3010',
    route: '/?token={TOKEN}',
    token: '48a2aa76b12453d4c335742c47a0b734',
  },
  {
    id: 'core-test',
    title: 'Hub Core — end-user demo (test sandbox)',
    description:
      'The new end-user Hub Core front door: login/register → "My apps" launcher → app catalog → account. Demo/mock backend, no live effects.',
    target: 'hub-core-test:3099',
    route: '/',
  },
];

/** Build the full owner-gated href for a sandbox card. */
export function sandboxHref(s: SandboxCard): string {
  const route = s.route.replace('{TOKEN}', encodeURIComponent(s.token ?? ''));
  return `/${s.id}${route}`;
}
